import React from 'react'
import insde from '../../../../assets/images/passengers/inside.jpg'
import outside from '../../../../assets/images/passengers/outside.jpg'
import PassengerCard from '../../../PassengerCard'

const ScheduleAirlines = () => {
  const types = [
    {
      title: "Ýerli uçuşlar",
      desc: "Ýurduň içinde ýolagçy howa gatnawlary barada maglumat",
      img: insde,
      href: "/passengers/schedule-airlines/inside"
    },  
    {
      title: "Halkara uçuşlar",
      desc: "Uçarlaryň ugraýan we gonýan wagtlary barada häzirki maglumatlar",
      img: outside,
      href: "/passengers/schedule-airlines/outside"
    }
  ]

  return (
    <div className='w-full'>
      <div className="w-[70%] mx-auto flex flex-row my-[5%] gap-12">
        {types.map((item) => (
          <PassengerCard props={item} />
        ))}
      </div>
    </div>
  )
}

export default ScheduleAirlines